// @TODO Rewrite or replace this s**t I wrote more than one year ago.

export const eventService = {
    emit(eventName, detail) {
        let evt;
        try {
            evt = new CustomEvent(eventName, { detail });
        } catch (error) {
            // IE11
            evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(eventName, true, true, detail);
        }
        document.dispatchEvent(evt);
    },
    on(eventName, listener) {
        document.addEventListener(eventName, (data) => {
            typeof listener === 'function' ? listener(data.detail) : null;
        });
    },
};
